module.exports = __webpack_public_path__ + "img/idx-game-bg.786e4ad.webp";